/* Keep Cloudrock's product title, copy, gallery and offer in the chosen color. */
(() => {
  const routes = {
    'Black | Black': '/products/cloudrock-waterproof-black',
    'Glacier | Alloy': '/products/cloudrock-mid-waterproof-glacier',
    'Earth | Black': '/products/cloudrock-mid-waterproof-earth',
    'Sphinx | Sand': '/products/cloudrock-mid-waterproof-sphinx',
    'Mineral | Aloe': '/products/cloudrock-mid-waterproof-mineral',
    'Trek Waterproof': '/products/cloudrock-mid-waterproof-mineral-aloe'
  };

  document.addEventListener('click', async (event) => {
    const swatch = event.target.closest('variant-swatch-king .swatch-view-item[role="radio"]');
    const productInfo = swatch?.closest('.product-info');
    const color = swatch?.getAttribute('aria-label');
    const path = routes[color];
    if (!productInfo || !path || location.pathname === path) return;

    event.preventDefault();
    event.stopImmediatePropagation();

    // Nos Cloudrock o tamanho é escolhido no Swatch King (não existe input "option1"): lê a variante atual do formulário.
    const size = productInfo.querySelector('variant-picker')?.selectedVariant?.option1
      || productInfo.querySelector('input[name="option1"]:checked')?.value;
    const destination = new URL(path, location.origin);
    for (const [key, value] of new URLSearchParams(location.search)) {
      if (key.startsWith('utm_')) destination.searchParams.set(key, value);
    }

    if (size) {
      try {
        const response = await fetch(`${path}.js`, { credentials: 'same-origin' });
        if (response.ok) {
          const product = await response.json();
          const match = product.variants?.find((variant) =>
            variant.option1 === size && variant.option2 === color
          );
          if (match) destination.searchParams.set('variant', match.id);
        }
      } catch (_) {
        // The destination still opens with its available default size.
      }
    }

    location.assign(destination.toString());
  }, true);
})();

/* 2026-09-22: galeria só com a cor da página, e a cor certa pré-selecionada (o Trek abria em "Black | Black"). */
(() => {
  const gallery = document.querySelector('product-gallery[data-tow-own-color]');
  if (!gallery) return;
  const own = gallery.getAttribute('data-tow-own-color');
  const hide = (gallery.getAttribute('data-tow-hide') || '').split(',').filter(Boolean).map(Number);
  const form = document.forms[gallery.getAttribute('form')];
  const refilter = () => {
    if (!hide.length) return;
    gallery.querySelectorAll('media-carousel').forEach((el) => el.dispatchEvent(new CustomEvent('carousel:filter', { detail: { filteredIndexes: hide } })));
    gallery.querySelectorAll('page-dots').forEach((el) => el.dispatchEvent(new CustomEvent('control:filter', { detail: { filteredIndexes: hide } })));
  };
  form?.addEventListener('variant:change', () => setTimeout(refilter, 0));

  if (new URLSearchParams(location.search).has('variant')) return;
  customElements.whenDefined('variant-picker').then(() => {
    const picker = document.querySelector('.product-info variant-picker');
    const input = [...(picker?.querySelectorAll('input[type="radio"]') || [])].find((radio) => radio.value === own);
    if (!input || input.checked || input.disabled) return;
    let frames = 0;
    const apply = () => {
      if (picker.product && picker.selectedVariant) input.click();
      else if (++frames < 180) requestAnimationFrame(apply);
    };
    apply();
  });
})();
